import { render, staticRenderFns } from "./AllGroupClassesCard.vue?vue&type=template&id=edf5aa90&scoped=true&"
import script from "./AllGroupClassesCard.vue?vue&type=script&lang=js&"
export * from "./AllGroupClassesCard.vue?vue&type=script&lang=js&"
import style0 from "./AllGroupClassesCard.vue?vue&type=style&index=0&id=edf5aa90&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf5aa90",
  null
  
)

export default component.exports